import React, { createContext } from 'react'
import type { MediaControls, MediaState } from './types'

export const MediaControlsContext = createContext<MediaControls | undefined>(
  undefined
)
export const MediaStateContext = createContext<MediaState | undefined>(
  undefined
)

export function useMediaControlsContext() {
  const context = React.useContext(MediaControlsContext)

  if (context === undefined) {
    throw new Error(
      'useMediaControlsContext must be used within a MediaProvider'
    )
  }

  return context
}

export function useMediaStateContext() {
  const context = React.useContext(MediaStateContext)

  if (context === undefined) {
    throw new Error('useMediaStateContext must be used within a MediaProvider')
  }

  return context
}
